<template>
	<div class="main-login">
		<div class="login-col">
			<section class="login">
				<div class="login-logo text-center">
					<img :src="companyLoginLogo" alt="admin-logo" width="180">
				</div>
				<!-- <p class="login-header">
					Te damos la bienvenida
				</p> -->
				<form class="login-inputs" id="login-form" @submit.prevent="signin">
					<div class="login-inputs-txt">
						<img :src="iconUser" alt="user" width="16">
						<div class="login-inputs-group">
							<input type="email"
								placeholder="Usuario"
								class="login-input"
								v-model="user"
								autocomplete="off"
								required>
						</div>
					</div>
					<hr class="login-spacer">
					<div class="login-inputs-txt">
						<img :src="iconPassword" alt="password" width="16">
						<div class="login-inputs-group">
							<input type="password"
								placeholder="Contraseña"
								class="login-input"
								v-model="password"
								autocomplete="off"
								required>
						</div>
					</div>
				</form>
				<div class="login-footer">
					<v-btn type="submit"
						form="login-form"
						class="login-btn"
						color="btn-login"
						:loading="isLoading"
						v-bind:class="{ disabled: isLoading }"
						accesskey="13"
						v-bind:disabled="isLoading"
						>
						Entrar
					</v-btn>
					<a :href="`https://wa.me/${phone_number}?text=Hola, tengo un problema al iniciar sesión en la plataforma.`" target="_blank" class="login-footer-pass">¿Olvidaste tu contraseña?</a>
					<!-- <p class="login-footer-pass" @click="openContactWsp(phone_number)">¿Olvidaste tu contraseña?</p> -->
				</div>
			</section>
		</div>
		<div class="login-col bg-imagen-login">
			<div>
				<!-- <div class="--container-promotion-banner">
					<img :src="backgroundCompany" alt="banner login" title="Login de tandia">
				</div> -->
				<div >
					<img :src="backgroundCompany" alt="banner login" title="Login de tandia">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import helper from '@/shared/helper';

async function checkSession() {
	try {
		const { data: checked } = await this.$httpSales.get('devices-validation');
		if (checked.codeMessage === 'TERMINAL_SESSION_EXIST') {
			this.showGenericError(`El punto de venta asignado al usuario con el que ingresó esta siendo usado por ${checked.deviceTerminal[0].userName}`, 7000);
		} else if (checked.codeMessage === 'TYPE_DEVICE_TERMINAL_INVALID') {
			this.showGenericError('El punto de venta en cual esta ingresando solo esta asignado a dispositivos móviles');
		} else {
			this.goTo('products');
		}
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function isLoged() {
	const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
	return token !== undefined && token != null && token !== '';
}

async function signin() {
	window.localStorage.clear();
	this.isLoading = true;
	const userData = {
		email: this.user,
		password: this.password,
		codeApp: process.env.APP_CODE,
	};
	try {
		const response = await this.$httpAcl.post('authenticate', userData);
		const user = response.data;
		const inLocalStorage = JSON.stringify(user);
		const { token, codeProject } = user;
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const requests = [
			this.$httpSales.get('employees/current', { headers }),
			this.$httpSales.get('/catalog-sunat-details-list/TABLA17', { headers }),
			this.$httpSales.get('/catalog-sunat-details-list/TABLA16', { headers }),
		];
		const [responseJapi, taxes, otherTaxes] = await Promise.all(requests);
		const userJapi = responseJapi.data;
		localStorage.setItem(process.env.STORAGE_USER_KEY, inLocalStorage);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::codeProject`, codeProject);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, token);
		helper.setLocalData('acl-id', userJapi.aclUserId);
		helper.setLocalData('acl-code', userJapi.aclUserCode);
		helper.setLocalData('admin-user', userJapi);
		helper.setLocalData('general-taxes', taxes.data);
		helper.setLocalData('other-taxes', otherTaxes.data);
		this.$bus.$emit('USER_INFO', userJapi);
		this.$ga.set('userId', userJapi.aclUserCode);
		this.countryId = userJapi.company.comCountryId;
		this.loadPlasticTaxes();
		this.checkSession();
	} catch (e) {
		if (e.status === 401) {
			if (e.data.code === 1153) {
				const info = e.data.infoData;
				this.showGenericError(`Actualmente esta conectado desde el dispositivo marca ${info.infoDevice.brand} modelo ${info.infoDevice.model}`, 100000);
			} else if (e.data.message === 'USER_WITH_PREVIOUS_CONNECTION') {
				this.showGenericError('Ya existe una sesión activa con el usuario ingresado.');
			}
		} else {
			this.showGenericError('Sus credenciales no son válidas');
		}
	} finally {
		this.isLoading = false;
	}
}

async function loadPlasticTaxes() {
	try {
		const { data: response } = await this.$httpSales.get(`/electronic-taxes/${this.countryId}/default`);
		helper.setLocalData('tax-icb', response);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		backgroundCompany: '/static/img/portada_referidos_4.webp',
		countryId: null,
		iconPassword: '/static/img/key.svg',
		iconUser: '/static/img/user.svg',
		companyLoginLogo: '/static/img/logo-normal.svg',
		user: '',
		password: '',
		isLoading: false,
		phone_number: process.env.PHONE_CHANGE_PASSWORD,
		// backgroundCompany: '/static/img/portada_referidos_2.png',
		// backgroundCompany: '/static/img/portada_referidos.png',
		// backgroundCompany: process.env.COMPANY_LOGIN_BACKGROUND,
		// iconPassword: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/key-(1).svg',
		// iconUser: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/group-14-(1).svg',
		// companyLoginLogo: process.env.COMPANY_LOGIN_LOGO,
	};
}

function mounted() {
	if (this.isLoged()) {
		this.goTo('products');
	}
	/* else {
		this.checkSession();
	} */
}

export default {
	name: 'login-per',
	mounted,
	data,
	methods: {
		checkSession,
		loadPlasticTaxes,
		signin,
		isLoged,
	},
};
</script>

<style lang="scss" scoped>

.main-login {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 3rem;
	min-height: 100vh;
	margin: 0 auto;
	max-width: 1100px;
	// justify-content: start;
	// background-position: center;
	// background-repeat: no-repeat;
	// background-size: cover;
	@media (max-width: 640px) {
		grid-template-columns: 1fr
	}

	.login-col{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.bg-imagen-login{
		@media (max-width: 640px) {
			display: none;
		}
		img{
			max-width: 500px;
			width: 100%;
			margin-top: -57px;
		}
	}
	.login {
		// position: relative;
		// top: 50%;
		// transform: translateY(-50%);
		// left: 14%;
		// text-align: center;
		// width: 412px;
		width: 100%;
		max-width: 300px;
		.login-logo {
			margin-bottom: 60px;
			text-align: center;
		}
		.login-header {
			color: #5364e1;
			font-family: map-get($fonts, lato-regular);
			font-size: 16px;
			text-align: center;
		}

		.login-inputs {
			font-size: 24px;
			margin-bottom: 30px;
			width: 100%;
			.login-inputs-txt {
				@include flex-between;
				.login-inputs-group {
					width: 90%;
					.login-input {
						@include txt-config (open-regular, medium16);
						color: #212D68;
						height: 60px;
						outline: none;
						width: 100%;
					}
					.login-error-message {
						@include txt-config (open-regular, small);
						color: map-get($colors, red-error);
						float: left;
					}
				}
			}
			.login-spacer {
				border: 1px solid map-get($colors, subheaderText);
				opacity: 0.7;
				width: 100%;
			}
		}
		.login-footer {
			// @include flex-around;
			.login-footer-pass {
				color: #818cbb;
				font-family: map-get($fonts, open-regular);
				font-size: 14px;
				margin: 0;
				text-align: center;
				margin-top: 1.5rem;
				cursor: pointer;
				display: block;
				text-decoration: none;
			}
			.login-btn {
				width: 100%;
				display: block;
				background: #5364e1;
				margin: 0;
				color: #FFF;
				// @include btn (success, #5364e1, 5px, 30px, 154px, auto, center, lato-regular, small10);
				// outline: none;
			}
			.login-btn:active {
				// @include active-btn;
			}
			.disabled {
				// @include btn (subheaderText, #5364e1, 5px, 30px, 154px, auto, center, lato-regular, small10);
			}
		}
	}
	.login-info {
		.login-info-text {
			color: #5364e1;
			font-family: map-get($fonts, lato-regular);
			font-size: map-get($sizes, medium18);
			margin-bottom: 30px;
		}
		.login-info-btn {
			@include btn (blue-btn, #5364e1, 5px, 45px, 127px, auto, center, lato-regular, large);
			cursor: pointer;
			display: block;
			text-decoration: none;
		}
		.login-info-btn:active {
			@include active-btn;
		}
	}
}

@keyframes autofill {
    to {
        color: #5364e1;
		background: transparent;
    }
}

input:-webkit-autofill {
    animation-name: autofill;
	animation-fill-mode: both;
	background-color: transparent !important;
}
.--container-promotion-banner{
	border-radius: 4px;
	overflow: hidden;
	background-color: #eff3ff;
	color: #5364e1;
	text-align: center;
	.--title{
		font-weight: 100;
		line-height: 1.3;
		color: #6b71a0;
		font-size: 16px;
    	font-weight: 700;
		strong{
			font-weight: 700;
			font-size: 20px;
			color: #5364e1;
		}
	}
	.--sub-title {
		color:#525574;
		margin: 4px 0 8px;
	}
	.--big-btn-info {
		background-color: #5763cf;
		color: #FFF;
		padding: 10px 5px;
	}
}
.--more-information {
	text-align: center;
    color: #2c3a57;
    margin: 15px 0 0;
	p {
		margin: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-per.vue